import './Button.scss'

export const Button = (props) => {
  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    <button class="button-54" role="button">{props.text}</button>
  )
}